export default "__VITE_ASSET__CQR$gYAy__"